import { makeAutoObservable } from 'mobx'

export class RightNavCtrlStore {
  constructor() {
    makeAutoObservable(this)
  }

  slopAnalysisDataSource: any = null
  slopDirectionAnalysisDataSource: any = null

  public currentVisible: string | undefined = undefined
  public currentVisibleMeType: boolean = false // only use for measure
  showPolygonOnMap: boolean = true

  public setCurrentVisible = (str: string | undefined) => {
    this.currentVisible = str
  }

  public setCurrentVisibleMeType = (bool: boolean) => {
    this.currentVisibleMeType = bool
  }

  public handleShowPolygonOnMap = (bool: boolean) => {
    this.showPolygonOnMap = bool
  }

  public setSlopAnalysisDataSource = (data: any) => {
    this.slopAnalysisDataSource = data
  }

  public setSlopDirectionAnalysisDataSource = (data: any) => {
    this.slopDirectionAnalysisDataSource = data
  }
}
